export function validateApiResponse(schema: any, data: any): void {
  const validation = schema.safeParse(data);

  if (!validation.success) {
    console.error('Validation error details:', validation.error.issues);
    throw new Error('Failed to validate API response: ' + validation.error.message);
  }
}

export function stripNullProperties(items: Array<any>): Array<any> {
  return items.map((item) => {
    return Object.fromEntries(Object.entries(item).filter(([, value]) => value !== null));
  });
}
